<template>
  <div class="receiptProduction-holder">
    <div class="columns is-multiline">
      <div class="column is-6">
        <div class="field">
          <div class="control has-icons-left">
            <span class="icon is-small is-left">
              <i class="mdi mdi-magnify"></i>
            </span>
            <input
              class="input"
              type="text"
              placeholder="Buscar receita"
              v-model.trim="searchText"
            />
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="buttons is-right">
          <button class="button is-primary" @click="openCreateEditModal()">
            Produzir
          </button>
        </div>
      </div>
      <div class="column is-12" v-if="productions.length > 0">
        <div class="table-holder">
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Lote</th>
                <th>Nome</th>
                <th>Fabricação</th>
                <th>Validade</th>
                <th>Ingredientes</th>
                <th>Pacotes</th>
                <th>Opções</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="receiptProduction in productions"
                :key="receiptProduction.id"
              >
                <td>{{ receiptProduction.batch }}</td>
                <td>{{ receiptProduction.receipt.name }}</td>
                <td>
                  {{
                    receiptProduction.manufacturingDate | moment("DD/MM/YYYY")
                  }}
                </td>
                <td>
                  {{ receiptProduction.expirationDate | moment("DD/MM/YYYY") }}
                </td>
                <td>
                  <div
                    v-for="supply in receiptProduction.supplies"
                    :key="supply.id"
                  >
                    {{ supply.ingredient.name }} ({{ supply.batch }})
                  </div>
                </td>
                <td>
                  <div
                    v-for="pack in receiptProduction.packedProducts"
                    :key="pack.id"
                  >
                    {{ getProducedQuantity(pack) }}
                  </div>
                </td>
                <td class="options-holder">
                  <a
                    class="option"
                    @click="openCreateEditModal(receiptProduction)"
                    >Editar</a
                  >
                  <a class="option" @click="remove(receiptProduction)"
                    >Excluir</a
                  >
                  <b-dropdown aria-role="list">
                    <template #trigger>
                      <a class="is-success" role="button">
                        Rastreabilidade Negativa
                      </a>
                    </template>

                    <b-dropdown-item aria-role="listitem"
                      ><a
                        class="option"
                        @click="printNegativeRastreability(receiptProduction)"
                        >Exportar PDF</a
                      ></b-dropdown-item
                    >
                    <b-dropdown-item aria-role="listitem">
                      <a class="option" @click="exportXLSL(receiptProduction)"
                        >Exportar .XLXS</a
                      >
                    </b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <paginate
          v-model="currentPage"
          :page-count="totalPages"
          :page-range="3"
          :click-handler="getData"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'ml-pagination pagination-sm'"
          :prev-class="'page-item'"
          :next-class="'page-item'"
          :next-link-class="'page-link'"
          :page-link-class="'page-link'"
          :page-class="'page-item'"
        >
        </paginate>
        <print-negative-rastreability
          style="display: none"
        ></print-negative-rastreability>
      </div>
      <div class="column is-12" v-else>
        <div class="no-items-to-show-msg">Nenhuma produção foi encontrada.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import CreateEditReceiptProductionModal from "../components/receiptProduction/CreateEditReceiptProductionModal";
import NotificationsWrapper from "../helpers/NotificationsWrapper";
import { EventBus } from "../helpers/EventBus";
import PrintNegativeRastreability from "../components/receiptProduction/PrintNegativeRastreability";
import utils from "../helpers/debounce";
import * as XLSX from "xlsx";
import * as _saveAs from "file-saver";
import * as moment from "moment";

export default {
  name: "ReceiptProduction",
  components: { PrintNegativeRastreability },
  data: () => ({
    currentPage: 1,
    searchText: ""
  }),
  computed: {
    ...mapState({
      productions: state => state.receiptProduction.receiptProductions,
      isLoadingData: state => state.receiptProduction.loading,
      totalPages: state => state.receiptProduction.totalPages
    })
  },
  watch: {
    searchText: function() {
      this.getReceiptByText();
    }
  },
  methods: {
    getProducedQuantity(pack) {
      let totalProducedInKg = (pack.quantity * pack.packing.size) / 1000;
      let output = pack.quantity + " x " + pack.packing.size + "g";
      output += " (" + totalProducedInKg + "Kg" + ")";
      return output;
    },
    ...mapActions({
      getReceiptProductions: "receiptProduction/getReceiptProductions",
      removeReceiptProduction: "receiptProduction/removeReceiptProduction",
      getPackings: "packing/getPackings"
    }),
    ...mapMutations({
      resetFilters: "receiptProduction/resetFilters",
      setReceiptFilters: "receiptProduction/setQueryFilters",
      setPage: "receiptProduction/setPage"
    }),
    openCreateEditModal(receiptProduction) {
      this.$modal.show(
        CreateEditReceiptProductionModal,
        { receiptProductionParam: Object.assign({}, receiptProduction) },
        {
          width: "700px",
          height: "auto",
          adaptive: true,
          scrollable: true,
          clickToClose: false
        },
        {
          closed: () => {
            this.getReceiptProductions();
          }
        }
      );
    },
    getData(pageNum) {
      const page = pageNum - 1;
      this.currentPage = pageNum;
      this.setPage(page);
      this.getReceiptProductions();
    },
    remove(receiptProduction) {
      this.$modal.show("dialog", {
        title: "Aviso de exclusão!",
        text: `Você deseja excluir a produção ${receiptProduction.receipt.name}?`,
        buttons: [
          {
            title: "Excluir",
            class: "vue-dialog-button error",
            handler: () => {
              this.removeReceiptProduction(receiptProduction.id)
                .then(() => {
                  NotificationsWrapper.success(
                    "Produção excluída com sucesso!"
                  );
                  this.$modal.hide("dialog");
                  if (this.productions.length === 1) {
                    this.getData(
                      this.currentPage > 0 ? this.currentPage - 1 : 0
                    );
                  } else {
                    this.getReceiptProductions();
                  }
                })
                .catch(error => {
                  const errorMessage = { error }.error.response.data.errors;
                  if (errorMessage === "This product has deliveries.") {
                    NotificationsWrapper.error(
                      "Não foi possível remover a produção: Essa produção já foi entregue!"
                    );
                  } else {
                    NotificationsWrapper.error(
                      "Não foi possível remover a produção!"
                    );
                  }
                });
            }
          },
          {
            title: "Cancelar", // Button title
            default: true, // Will be triggered by default if 'Enter' pressed.,
            handler: () => {
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    exportXLSL(receipt) {
      let wb = XLSX.utils.book_new();

      wb.Props = {
        Title: "Rastreabilidade negativa",
        Subject: "",
        Author: "Petit Nature",
        CreatedDate: new Date()
      };

      XLSX.utils.book_append_sheet(
        wb,
        this.getNegativeRastreabilityRows(receipt),
        "Rastreabilidade negativa"
      );

      let wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
      const fileName =
        "rastrabilidade-negativa-" + moment().format(`DD-MM-YYYY-mm-ss`);
      let buf = this.s2ab(wbout);
      _saveAs.saveAs(
        new Blob([buf], { type: "application/octet-stream" }),
        `${fileName}.xlsx`
      );
    },
    s2ab(s) {
      let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      let view = new Uint8Array(buf); //create uint8array as viewer
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
      return buf;
    },
    getNegativeRastreabilityRows(receipt) {
      let ws_data = [
        ["Produto Final", receipt.receipt.name],
        ["Lote", receipt.batch],
        [
          "Data de fabricação",
          moment(receipt.manufacturingDate).format("DD/MM/YYYY")
        ],
        [
          "Data de validade",
          moment(receipt.expirationDate).format("DD/MM/YYYY")
        ],
        [],
        [
          "Insumo",
          "Lote",
          "Data de compra",
          "Validade",
          "Preço",
          "Kg",
          "Nª NF/",
          "Fornecedor"
        ]
      ];
      receipt.supplies.forEach(s => {
        const expDate = s.expirationDate
          ? moment(s.expirationDate).format("DD/MM/YYYY")
          : "";
        const purchaseDate = s.purchaseDate
          ? moment(s.purchaseDate).format("DD/MM/YYYY")
          : "";
        ws_data.push([
          s.ingredient.name,
          s.batch,
          expDate,
          purchaseDate,
          s.price || 0,
          s.size || 0,
          s.nfNumber,
          s.manufacturer.name
        ]);
      });

      return XLSX.utils.aoa_to_sheet(ws_data);
    },
    printNegativeRastreability(receipt) {
      EventBus.$emit("print:negativeRastreability", receipt);
    }
  },
  mounted() {
    this.getReceiptByText = utils.debounce(() => {
      this.resetFilters();
      this.setReceiptFilters({ name: this.searchText, limit: 5 });
      this.getReceiptProductions();
    }, 300);
  },
  created() {
    this.getReceiptProductions();
    this.getPackings();
    this.$store.commit("setSelectedViewTitle", "Receitas produzidas");
  }
};
</script>

<style lang="scss" scoped></style>
